import type {
  WebTagFindListOutputDto,
  WebTagFindListSpecialContentDeepDto,
  WebTagFindListSpecialOutputDto,
  WebTagFindOneOutputDto,
} from '@bldsoft/ovp-api-types'
import type { Content, Tag } from '@setplex/tria-api'
import { MediaTypes } from '@setplex/tria-api'
import { toDate } from '../../tools'
import { formatContentType } from '../../utils/contentType'
import type { ApiTag } from './index.h'

const isSpecialTag = (tag: ApiTag): tag is WebTagFindListSpecialOutputDto =>
  '_createDate' in tag

const formatSpecialTagContent = (
  content: WebTagFindListSpecialContentDeepDto
): Content => ({
  id: content.id,
  title: content.title,
  banner: content.banner,
  poster: content.poster,
  duration: String(content.duration),
  createDate: toDate(content.createDate),
  updateDate: toDate(content.updateDate),
  isFavorite: false,
  newOtherTags: [],
  contentType: MediaTypes.VIDEO,
})

export const formatFromOne = ({
  id,
  title,
  description,
  horizontalImage,
  background,
  contentTypes,
  seoMetadata,
}: WebTagFindOneOutputDto): Tag => ({
  id,
  title,
  description,
  horizontalImage,
  background: background ? [...background] : undefined,
  contentTypes: formatContentType(contentTypes),
  seoMetadata,
})

export const formatFromList = ({
  id,
  title,
  description,
  horizontalImage,
  background,
  createDate,
}: WebTagFindListOutputDto): Tag => ({
  id,
  title,
  description,
  horizontalImage,
  background: background ? [...background] : undefined,
  createDate: toDate(createDate),
})

export const formatFromSpecial = ({
  id,
  title,
  description,
  background,
  content,
  _createDate,
  _horizontalImage,
}: WebTagFindListSpecialOutputDto): Tag => ({
  id,
  title,
  description,
  horizontalImage: _horizontalImage,
  background: background ? [...background] : undefined,
  content: [formatSpecialTagContent(content)],
  createDate: toDate(_createDate),
})

export const format = (tag: ApiTag): Tag => {
  if (isSpecialTag(tag)) {
    return formatFromSpecial(tag)
  }

  if ('createDate' in tag) {
    return formatFromList(tag)
  }

  return formatFromOne(tag)
}
